import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ApiService} from '../../api.service';

@Component({
    selector: 'app-available-tags',
    templateUrl: './available-tags.component.html',
    styleUrls: ['./available-tags.component.css']
})
export class AvailableTagsComponent implements OnInit {
    @Input() module: string;
    @Output() selection = new EventEmitter<Array<string>>();
    public availableTags;
    public selectedTags = [];
    constructor(protected apiService: ApiService) {
    }

    ngOnInit() {
        this.getTags();
    }

    getTags() {
        this.apiService.getTags(this.module).subscribe((value) => {
            this.availableTags = value;
            this.availableTags.sort((a, b) => {
                return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
            });
        });
    }

    toggleTag(tag) {
        const isSelected = this.selectedTags.indexOf(tag) > -1;
        if (isSelected) {
            this.removeTag(tag);
        } else {
            this.addTag(tag);
        }
        this.selection.emit(this.selectedTags);
    }


    addTag(tag) {
        if (this.selectedTags.indexOf(tag) === -1) {
            this.selectedTags.push(tag);
        }
        this.selection.emit(this.selectedTags);
    }

    removeTag(tag) {
        this.selectedTags.splice( this.selectedTags.indexOf(tag), 1 );
        this.selection.emit(this.selectedTags);
    }

    clearSelectedTags() {
        this.selectedTags = [];
        this.selection.emit(this.selectedTags);
    }

}



// WEBPACK FOOTER //
// ./src/app/tags/available-tags/available-tags.component.ts